/**
 * Returns a lowercase search text string with trailing and multiple spaces removed.
 */
export function getFilteredSearchText(text: string): string {
  return text
    .trim()
    .toLocaleLowerCase()
    .replace(/ +(?= )/g, '')
}
